/*
 * Copyright © 2022 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import { NgZone, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
    // FcAgContextService,
    // FcAgLoadingMaskService,
    // FcResponsiveAgGridOptions,
    // FcAgDatepickerTypes,
    // FcDatePickerFormat,
    FcResponsiveAgDialogService
} from 'ag-libraries';
import { AppService } from './app.service';
import { 
    FcPreviewDocumentFileFormComponent 
} from './fc-preview-document-file-form/fc-preview-document-file-form.component';

/**
 * App root component with Angular.
 */
@Component({
    selector: 'fc-app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit  {
       
    /**
     * App constructor.
     * 
     * @param translateService TranslateService.
     * @param zone Zone.
     * @param appService AppService.
     * @param fcResponsiveAgDialogService FcResponsiveAgDialogService.
     */
    constructor(
                private translateService: TranslateService,
                private zone: NgZone,
                private appService: AppService,
                private fcResponsiveAgDialogService: FcResponsiveAgDialogService
    ) {
    }
    
    /**
     * OnInit lifecycle.
     */
    ngOnInit(): void {
        this.appService.windowRef.FC.utils.addListener('show-document-shared-ag-ui', (data: any) => {
            this.zone.run(() => {
                this.previewDocument(data);
            });
        });
    }

    /**
     * Open preview document.
     * 
     * @param data Data.
     */
    previewDocument(data: string) {
        this.appService.getPdftronLicenseKey()
            .subscribe((response: any) => {
                this.openPreviewDialog(data, response);
            },
            () => {
                this.openPreviewDialog(data, '');
            });
    }

    /**
     * Open preview document dialog.
     *
     * @param data Data.
     * @param licenseKey LicenseKey.
     */
    openPreviewDialog(data: any, licenseKey: any) {
        this.fcResponsiveAgDialogService.addModal(FcPreviewDocumentFileFormComponent, {
            data,
            licenseKey
        }, {
            wrapperClass: 'preview-document-dialog-wrapper'
        }).subscribe((isSubmitted: boolean) => {
        });
    }
}
